export default "__VITE_ASSET__pLYicxRi__"